import groq from "groq";

const FranchiseInquiryPageBuilderQuery = groq`
  *[_id == $documentId][0].pageBuilder
`;

export { FranchiseInquiryPageBuilderQuery };
